import { useSignal } from '@preact/signals'

import { signOut } from 'state/auth'
import { Typography } from 'components/UI'

import { LogoutModal } from './LogoutModal'

const SignOutButton = () => {
	const isLogoutModalOpen = useSignal(false)

	const openLogoutModal = () => {
		isLogoutModalOpen.value = true
	}

	const closeLogoutModal = () => {
		isLogoutModalOpen.value = false
	}

	const handleLogout = () => {
		signOut()
		closeLogoutModal()
	}

	return (
		<>
			<button
				aria-label='Sign out'
				class='group flex h-10 w-full flex-1 cursor-pointer items-center gap-2 px-2.5 py-2 text-black-200 hover:bg-black-800 hover:text-black-100'
				onClick={openLogoutModal}
				type='button'
			>
				<Typography
					color='text-black-200 group-hover:text-black-100'
					text='Sign Out'
					variant='text3'
					weight='font-normal'
				/>
			</button>

			<LogoutModal
				isModalOpen={isLogoutModalOpen}
				logout={handleLogout}
				onCloseLogoutModal={closeLogoutModal}
			/>
		</>
	)
}

export { SignOutButton }
